import { Gaussian } from "./gaussian/Gaussian.js";
import { GeneralizedLorentzian } from "./generalizedLorentzian/GeneralizedLorentzian.js";
import { Lorentzian } from "./lorentzian/Lorentzian.js";
import { LorentzianDispersive } from "./lorentzianDispersive/LorentzianDispersive.js";
import { PseudoVoigt } from "./pseudoVoigt/PseudoVoigt.js";
import { PseudoVoigtTCH } from "./pseudoVoigtTCH/PseudoVoigtTCH.js";
import { SplitGaussian } from "./splitGaussian/SplitGaussian.js";
export function getShape1D(shape) {
    const { kind } = shape;
    switch (kind) {
        case 'gaussian':
            return new Gaussian(shape);
        case 'lorentzian':
            return new Lorentzian(shape);
        case 'pseudoVoigt':
            return new PseudoVoigt(shape);
        case 'pseudoVoigtTCH':
            return new PseudoVoigtTCH(shape);
        case 'lorentzianDispersive':
            return new LorentzianDispersive(shape);
        case 'generalizedLorentzian':
            return new GeneralizedLorentzian(shape);
        case 'splitGaussian':
            return new SplitGaussian(shape);
        default:
            throw new Error(`Unknown distribution ${kind}`);
    }
}
//# sourceMappingURL=getShape1D.js.map